"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CONTENT_TILES_DEFAULT_COUNT = void 0;
exports.CONTENT_TILES_DEFAULT_COUNT = 14;
//# sourceMappingURL=ContentTileListerConstants.js.map